export default class Layoutgrid {
  constructor() {
    // 1. Create the button
    const button = document.createElement('button');
    button.className = 'js-toggle-layout-grid layout-grid__button';
    button.innerHTML = 'Show layout';

    // 2. Append somewhere
    const body = document.getElementsByTagName('body')[0];
    body.appendChild(button);

    // 3. Add event handler
    button.addEventListener('click', () => {
      if (body.classList.contains('show--layout-grid')) {
        body.classList.remove('show--layout-grid');
        button.innerHTML = 'Show layout';
      } else {
        body.classList.add('show--layout-grid');
        button.innerHTML = 'Hide layout';
      }
    });
  }
}
